<template>
    <div class="vertical_line homeComTitle hasLine">
        <span class="titleLine"></span>
        <span class="flex_1 fs16 co_333">{{ title }}</span>
    </div>
</template>

<script>


export default {
    name: "VerticalLine",
    props: {
        title: {
            type: String,
            defalut: ""
        },

    }
}
</script>

<style lang="scss" scoped>
.vertical_line{
    font-family: PingFangSC-Regular;

}
</style>